import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-map-position-icon',
  templateUrl: './map-position.component.html'
})
export class MapPositionComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
